import http from './lib.js'
import { configHandler, httpHandler, dataHandler } from './handler.js'

export const custom = {
	// 获取文件
	xml: function(url = '') {
		return httpHandler.get(url).then(text => {
			let status = 'error';
			let data = '';
			if (text) {
				status = 'success';
				data = text;
			}
			return {
				status,
				data
			};
		});
	},
    // 获取方程式库/序列数据
    phamula: function(url = '') {
    	return httpHandler.get(url).then(text => {
    		let status = 'error';
    		let data = {};
    		if (text && typeof text === 'object') {
    			status = 'success';
    			data = text;
    		}
    		return {
    			status,
    			data
    		};
    	});
    },
    // 获取聊天记录
    getChatMessagesList: function(url = '', req = {}) {
    	return httpHandler.post(url, req);
    }
};

export const user = {
	login: function(data = {}) {
        const { APP_ID } = configHandler();
		data.app_id = data.app_id || APP_ID;
		data.language = data.language || '1';
		return http.post('/home/user/login', data);
	},
	register: function(data = {}) {
        const { APP_ID } = configHandler();
		data.app_id = data.app_id || APP_ID;
		return http.post('/home/user/register', data);
	},
	profile: function() {
		return http.post('/home/user/profile', {}).then(res => {
			if (res.status === 'success') {
				res.data = dataHandler.userHandler(res.data);
			}
			return res;
		});
	},
	public_profile: function(user_id = '') {
		return http.post('/home/user/public_profile', { user_id }).then(res => {
			if (res.status === 'success') {
				res.data['user_id'] = user_id;
				res.data = dataHandler.userHandler(res.data);
			}
			return res;
		});
	},
	set_profile: function(data = {}) {
		return http.post('/home/user/set_profile', data);
	},
	punch_daka: function(data = {}) {
		return http.post('/home/user/punch_daka', data);
	},
	report_bug: function(content = '') {
		return http.post('/home/user/report_bug', { content });
	},
	liked_object_list: function() {
		return http.post('/home/user/liked_object_list', {});
	},
	send_mobile_verifycode: function(mobile = '') {
		return http.post('/home/user/send_mobile_verifycode', { mobile });
	},
	check_mobile_verifycode: function(data = {}) {
		return http.post('/home/user/check_mobile_verifycode', data);
	}
};

export const event = {
	search: function(data = {}) {
		return http.post('/home/event/search', data).then(res => {
			if (res.status === 'success') {
				res.data = dataHandler.addBaseUrl(res.data, 'picture');
				res.data = dataHandler.strToNum(res.data, ['booked_num', 'checkedin_num', 'is_canceled', 'length', 'max_num']);
				res.data = res.data.map(v => Object.assign(v, dataHandler.eventDescription(v.description)));
			}
			return res;
		});
	}
};

export const tuwen = {
	detail: function(tuwen_id = '') {
		tuwen_id = tuwen_id || store.state.tuwen_id;
		return http.post('/home/tuwen/detail', { tuwen_id }).then(res => {
			if (res.status === 'success') {
				res.data.content = dataHandler.htmlDecode(res.data.content);
				res.data.string = dataHandler.trimHtml(res.data.content);
			}
			return res;
		});
	}
};

export const order = {
	add: function(data = {}) {
		return http.post('/home/order/add', data);
	},
	lists: function(data = {}) {
		return http.post('/home/order/lists', data).then(res => {
			if (res.status === 'success') {
				if (res.data.list && res.data.list.length) {
					res.data.list = dataHandler.strToNum(res.data.list, ['quantity', 'is_digital', 'is_fulfilled', 'is_single_product', 'is_payment_complete']);
				}
			}
			return res;
		});
	}
};

export const object = {
	detail: function(object_id = '') {
		return http.post('/home/object/detail', { object_id }).then(res => {
			if (res.status === 'success') {
				res.data = dataHandler.objHandler(res.data);
			}
			return res;
		});
	},
	is_liked: function(object_id = '') {
		return http.post('/home/object/is_liked', { object_id }).then(res => {
			if (res.status === 'success') {
				res.data.is_liked = Number(res.data.is_liked);
			}
			return res;
		});
	},
	add_like: function(object_id = '') {
		return http.post('/home/object/add_like', { object_id });
	},
	del_like: function(object_id = '') {
		return http.post('/home/object/del_like', { object_id });
	},
	// like_list: function(object_id = '') {
	// 	return http.post('/home/object/like_list', { object_id });
	// },
	// like_count: function(object_id = '') {
	// 	return http.post('/home/object/like_count', { object_id });
	// },
	detail_list: function(object_ids = '') {
		return http.post('/home/object/detail_list', { object_ids }).then(res => {
			if (res.status === 'success') {
				res.data = res.data.map(object => dataHandler.objHandler(object));
			}
			return res;
		});
	}
};

export const message = {
	send: function(data = {}) {
		return http.post('/home/message/send', data).then(res => {
			if (res.status === 'success') {
				res.data.message_id = String(res.data.message_id);
			}
			return res;
		});
	}
};

export const phamula = {
	detail: function(phamula_id = '') {
		return http.post('/home/phamula/detail', { phamula_id }).then(res => {
			if (res.status === 'success') {
				if (res.data) {
					try {
						res.data.obj_relation_json = JSON.parse(res.data.obj_relation_json);
						res.data.obj_relation_json.type = Number(res.data.obj_relation_json.type);
						res.data.obj_relation_json.layer = dataHandler.treeLayer(res.data.obj_relation_json.jsonStr);
					} catch(err) {
						res.data.obj_relation_json = {
							jsonStr: {},
							layer: 0,
							name: '',
							type: -1
						};
					}
				} else {
					// res.data = {
					// 	phamula_id: phamula_id,
					// 	obj_relation_json: {
					// 		jsonStr: {},
					// 		layer: 0,
					// 		name: '',
					// 		type: -1
					// 	}
					// };
					res.status = 'error';
					res.data = null;
				}
			}
			return res;
		});
	}
};

export const booking = {
	add: function(data = {}) {
		return http.post('/home/booking/add', data);
	},
	search: function(data = {}) {
		return http.post('/home/booking/search', data).then(res => {
			if (res.status === 'success') {
				res.data = dataHandler.strToNum(res.data, ['is_paid', 'is_checkedin']);
			}
			return res;
		});
	},
	pay_result: function(data = {}) {
		return http.post('/home/booking/pay_result', data);
	}
};